export var nameRegex = /(\w+) (\w+)/;
export function unmask(value) {
    return value.replace(/[^\d]/g, '');
}
//# sourceMappingURL=shared.js.map